var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NodeViewWrapper',{staticClass:"button-node-view"},[_c('ButtonComponent',{style:(_vm.resolvedStyle),attrs:{"label":_vm.node.attrs.label,"icon":_vm.node.attrs.icon,"theme":_vm.node.attrs['data-cta']},on:{"click":function($event){$event.preventDefault();}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }